const localStorage = () => window.localStorage;

export default {
  localStorage
};
